import { render, staticRenderFns } from "./ResumeDossier.vue?vue&type=template&id=630b65b2&"
import script from "./ResumeDossier.vue?vue&type=script&lang=js&"
export * from "./ResumeDossier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports